var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_97",
    "data-name": "Group 97",
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.938,
    height: 122.889,
    viewBox: "0 0 133.938 122.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M27.335,11.238a2.258,2.258,0,0,0-2.257,2.257V49.657a2.258,2.258,0,0,0,2.257,2.257H48.587a2.257,2.257,0,1,0,0-4.514h-19V13.495A2.258,2.258,0,0,0,27.335,11.238Z",
    transform: "translate(45.134 11.806)",
    fill: "#3d99b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M99.561,9.084A61.034,61.034,0,0,0,52.569,7.552,61.755,61.755,0,0,0,13.239,58.014L5.9,46.5a2.255,2.255,0,1,0-3.8,2.425l11.04,17.332c.036.057.1.084.141.138a2.221,2.221,0,0,0,.439.433,2.308,2.308,0,0,0,.292.19,2.127,2.127,0,0,0,.6.193c.087.018.162.069.25.078.063,0,.126.006.19.006a2.187,2.187,0,0,0,.9-.19c.069-.03.12-.09.19-.126a2.3,2.3,0,0,0,.548-.4c.012-.018.033-.021.045-.036L30.477,51.276a2.258,2.258,0,1,0-3.355-3.024L17.7,58.715A57.2,57.2,0,0,1,54.161,11.774a56.917,56.917,0,0,1,71.9,76.754A56.916,56.916,0,0,1,20.954,85.092a2.257,2.257,0,1,0-4.225,1.592,61.43,61.43,0,1,0,82.832-77.6Z",
    transform: "translate(-1.744 -3.58)",
    fill: "#141414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistory);
export default __webpack_public_path__ + "static/media/PaymentHistory.eae34b78f585c6b38799070777cdbd67.svg";
export { ForwardRef as ReactComponent };